var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThirdparty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3823 47.2545L31.855 38.0909L24.0005 23.2545L16.1459 37.2182L3.92773 47.2545H19.2005H45.3823Z",
    fill: "#DDE2E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.930054L0 48.9301H48L24 0.930054ZM24 25.9308L29.5376 36.5738H18.4624L24 25.9308ZM22.5938 22.4076L14.9957 37.0107L6.17782 42.9919L22.5938 10.1599V22.4076ZM16.4382 39.6629H31.5618L40.6701 45.841H7.33L16.4382 39.6629ZM33.0043 37.0107L25.4062 22.4076V10.1599L41.8222 42.9919L33.0043 37.0107Z",
    fill: "#6E7C87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdparty);
export default __webpack_public_path__ + "static/media/thirdparty.8fbde5a6536b5179bc88a54bd105bd9f.svg";
export { ForwardRef as ReactComponent };